/* Mount-once bootstrap for native (APNs/FCM via AWS SNS) push registration.

   Pairs with `<PushAutoEnablePrompt />` for web push so the two channels
   coexist cleanly:
     - On a browser → this component is a no-op; the prompt handles VAPID.
     - Inside the Capacitor shell on iOS/Android → this component asks for
       notification permission, registers with APNs/FCM and uploads the
       device token to the backend. */
import useNativePush from "../../lib/useNativePush";

export default function NativePushBootstrap() {
  useNativePush();
  return null;
}
